import createDarkLightColors from "./createDarkLightColors.js";
import syntaxCheckAndConvertToHex from "./syntaxCheckAndConvert.js";

/**
 * @typedef {object} generatedColors
 * @property {string} dark - dark color
 * @property {string} light - light color
 */

/**
 *
 * @param {string[]} hexColorOrName rgb color in hex or known color name or r,g,b
 * @returns {generatedColors} object with light color and dark color
 * @description create object with light color and dark color.
 * it will use the color to decide with color to create
 * for example if you provide light color it will calc dark color
 * and will detect light/dark automatically
 */
const runColors = (...hexColorOrName) => {
  if (Array.isArray(hexColorOrName[0])) hexColorOrName = [...hexColorOrName[0]];
  let res = syntaxCheckAndConvertToHex(...hexColorOrName);
  if (!res) return null;
  let colors;
  if (res.sameColor) {
    colors = {
      light: res.hex,
      dark: res.hex,
    };
  } else {
    colors = createDarkLightColors(res.hex);
  }
  if (res.swipeTheme) {
    let tmp = colors.light;
    colors.light = colors.dark;
    colors.dark = tmp;
  }
  return colors;
};

export default runColors;
